export default __webpack_public_path__ + "static/media/speedboat.763cb2ba.jpg";